import './actiondetail.scss'

import {ActionsChannelData} from '../../../../campagne/types'
import {BannerCta} from '../banner'
import {DownloadPromo} from 'views/campagne/promo/downloadpromo'
import {Image} from '@codeurs/front'
import {Practical} from '../practical'
import {Progressbar} from '../../../ui/Progressbar'
import React from 'react'
import {Share} from '../share'
import {TeamDonations} from '../../../pages/team/TeamDonations'
import {TeamSupport} from '../../../pages/team/TeamSupport'
import {Theme} from 'views/campagne/theme'
import {VideoContainer} from '../../partials/blocks/videoblock'
import {dateFromServerDate} from 'util/dates'
import {style} from 'util/campagne/style'
import {useTranslation} from 'util/i18n'

const styles = style('actiondetail')

export const ActionDetail: React.FC<ActionsChannelData & any> = ({
	totalAmount,
	actionSupport,
	featured,
	banner,
	description_short,
	description_long,
	donations,
	image,
	thanks,
	affiche_with,
	affiche_what,
	affiche_where,
	location_name,
	date_start,
	date_end,
	date_has_multiple_days,
	date_has_end_hour,
	address,
	organisator_name, // This field is deprecated, but we keep the data for backward compatibiltiy with old actions
	organisator_firstname,
	organisator_lastname,
	organisator_contact_details,
	subscription_required,
	private: isPrivate,
	hero,
	external_url,
	subscription_details,
	...rest
}) => {
	const start = dateFromServerDate(date_start)
	const end = dateFromServerDate(date_end)
	const dateInfo = {
		start,
		end,
		hasEndDate: date_has_multiple_days,
		hasEndHour: date_has_end_hour
	}
	const poster = {
		organisation: affiche_with,
		sharing: affiche_what,
		location: affiche_where,
		venue: location_name,
		...dateInfo
	}
	const practical = {
		address,
		owner:
			organisator_firstname || organisator_lastname
				? (organisator_firstname + ' ' + organisator_lastname).trim()
				: organisator_name,
		email: organisator_contact_details,
		subscriptionRequired: subscription_required,
		isPublic: !isPrivate,
		external_url,
		subscription_details,
		...dateInfo
	}
	const t = useTranslation('campagne').action
	return (
		<div class={styles}>
			<Theme.Container>
				<div class={styles('top')}>
					<div class={styles('top-share')}>
						<Share text={t.share} copy={hero && hero.title} mod="with_border" />
					</div>
				</div>
			</Theme.Container>
			<Theme.Container>
				<div class={styles('cols')}>
					<div class={styles('cols-blocks')}>
						<Progressbar
							value={totalAmount}
							text="Deze actie bracht al € op"
							total={0}
							className={styles('cols-blocks-progressbar')}
						/>
						<div class={styles('cols-blocks-short')}>
							Enkel als je een bedrag overschrijft via de steunknop op deze
							pagina of via de unieke gestructureerde mededeling, komt jouw gift
							tevoorschijn in deze teller.
						</div>
						{image && (
							<div class={styles('cols-blocks-image')}>
								<Image {...image} />
							</div>
						)}
						<div class={styles('cols-blocks-long')}>
							<Theme.Wysiwyg>{description_long}</Theme.Wysiwyg>
						</div>
						{hero && hero.video && (
							<div class={styles('cols-blocks-video')}>
								<VideoContainer url={hero.video} />
							</div>
						)}
						<div class={styles('cols-blocks-practical')}>
							<Practical {...practical} />
						</div>
					</div>
					<div class={styles('cols-info')}>
						{actionSupport.ogm && (
							<TeamSupport
								{...actionSupport}
								title="Steun deze actie of stort je opbrengst door"
								buttonLabel="Klik hier"
								// buttonPosition="top"
								className={styles('cols-info-support')}
								showTransfer={false}
							/>
						)}
						<TeamDonations
							className={styles('cols-info-donations')}
							donations={donations}
						/>
						<div class={styles('cols-info-promo')}>
							<DownloadPromo {...poster} />
						</div>
					</div>
				</div>
				<div class={styles('banner')}>
					<BannerCta
						headingLeft={banner.title1}
						headingRight={banner.title2}
						description={banner.text}
						ctaLink={banner.link}
						{...banner}
					/>
				</div>
			</Theme.Container>
		</div>
	)
}
